import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { SessionStorageService } from 'app/shared/services/session-storage.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';

@Component({
  selector: 'app-client-report',
  templateUrl: './client-report.component.html',
  styleUrls: ['./client-report.component.scss',
  "../../../../../../assets/sass/libs/datatables.scss",],
  encapsulation: ViewEncapsulation.None,
})
export class ClientReportComponent implements OnInit {

 @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber:0,
    offset: 0,
    pageSize: 100,
    totalPages:0
  };
  // row data
  public rows = [];
  public filterRows=[];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue=''
  isFilter:boolean=false
  // column header
  public columns = [
    { name: " Name", prop: "name" },
    { name: "Email", prop: "email" },
    { name: "Phone", prop: "phone" },
    { name: "Actions", prop: "actions" },
  ];

  // private
  private tempData = []; 
  imageUrl=environment.apiUrls.imageUrl;
  user_role: any
  type_List = []
  business_type_cat_id = '631ad8d1ce5c666542591bdd'
  activeTab: any
  contact_data = []
  row_name: any
  client_id:any

  guideline_data:any

  constructor(public apiService:ApiService,
              public toastr: ToastrService,
              private modalService: NgbModal,
              private session: SessionStorageService,
              private activerouter: ActivatedRoute,
               private spinner: NgxSpinnerService,
              private route: Router,private resolver: ComponentFactoryResolver ) { 
    this.user_role = JSON.parse(localStorage.getItem('user'))
    let setting_data = JSON.parse(localStorage.getItem('setting-record'))
    let key_data = setting_data.filter((item) => item.key == 'Client Report') 
    this.guideline_data = key_data[0]?._id
    this.getTypeList()
              }

  ngOnInit(): void {
    setTimeout(() => {
      this.getBusinessList()
    }, 1000);
    
    
    // this.activeEmployeeTab('College')
  }
  getTypeList() {
       
        this.apiService.getTagByTagCatgoryId(this.business_type_cat_id).subscribe((res: any) => {
          this.type_List = res.data
          this.client_id = this.type_List.filter((item) => item.name == 'client')
          // console.log(this.client_id)
          // this.setAndGetEmployeebyStatus()
        })
  }
  //   activeEmployeeTab(tab) {
  //   const activetab = tab;
  //   this.activeTab = tab
  //   if (activetab !== '') {
  //     this.route.navigate(
  //       [],
  //       { relativeTo: this.activerouter, queryParams: { status: activetab } }
  //     );
  //   }
  // }
  // setAndGetEmployeebyStatus() {
  //   this.activerouter.queryParams
  //     .subscribe((params: any) => {
  //       this.activeTab = params?.status;
  //      this.getBusinessList()
  //     })
  // }



  getBusinessList() {
     this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    // let status = this.type_List.find((item) => item.name == this.activeTab);
    this.apiService.getBusinessByTypeId(this.client_id[0]?._id).subscribe((res: any) => {
      this.spinner.hide()
      this.rows = res?.data
      this.page.totalPages=res.data.length
    })
  }
  pageChangeData(page:any) {
    this.apiService.getContactList(page.offset +1,page.pageSize).subscribe((res:any)=>{
      this.rows =res.data.items
      this.page.totalPages=res.data.totalCount
    }) 
  }
  getContactFilter(event:any){
    let search=event.target.value
    if(search){
      this.apiService.contactSearch(search).subscribe((res:any)=>{
        this.rows =res.data
      })
    }
    else{
      // this.getContactList()
    }
  }
getContactByBusId(id) {
    if(id){
      this.apiService.getContactByBusinessId(id).subscribe((res: any) => {
        this.contact_data =res.data
      })
    }
  }
  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }
  
}
